<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><span href="#/OEBPS/toc#ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></h1>
<p class="nonindent">I am indebted to the following individuals, organizations and institutions for their assistance, without which the writing of this book would have been considerably harder: John Keep, Dr James Roy/University of Nottingham, Asa Hutchinson/US Department of Justice, Anne Chippindale/<em>Antiquity</em> Publications, Dr Jonathan King/North America Curator in the Department of Ethnography at the British Museum, William Breeze, Gerald Laishley, Free Rob Cannabis, Chris Hinett of Henry &amp; Company/Solicitors, Devon County Library, Drug Enforcement Administration/Washington DC, Federal Bureau of Investigation, Central Intelligence Agency, HM Customs and Excise, the Historic Dockyard: Chatham, the Metropolitan Police/London, the Ashmolean Museum, the Bodleian Library, the British Medical Association, the State University of New York Upstate Medical University Health Sciences Library, the Kappa Alpha Fraternity, the Library of the House of Lords, GW Pharmaceuticals Ltd, Princeton University Library, Hemcore Ltd, Penn State University, National Museum of Health and Medicine/Washington DC, United Nations Office for Drug Control and Crime Prevention/Vienna, the Body Shop International, NORML and, finally, my wife, Helen, whose research skills are quite immeasurable.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?48368c98